function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var genCollapseMotion = function genCollapseMotion(token) {
  var _token$componentCls;

  return _defineProperty({}, token.componentCls, (_token$componentCls = {}, _defineProperty(_token$componentCls, "".concat(token.antCls, "-motion-collapse-legacy"), {
    overflow: 'hidden',
    '&-active': {
      transition: "height ".concat(token.motionDurationMid, " ").concat(token.motionEaseInOut, ",\n        opacity ").concat(token.motionDurationMid, " ").concat(token.motionEaseInOut, " !important")
    }
  }), _defineProperty(_token$componentCls, "".concat(token.antCls, "-motion-collapse"), {
    overflow: 'hidden',
    transition: "height ".concat(token.motionDurationMid, " ").concat(token.motionEaseInOut, ",\n        opacity ").concat(token.motionDurationMid, " ").concat(token.motionEaseInOut, " !important")
  }), _token$componentCls));
};

export default genCollapseMotion;